import moment from 'moment';

const clone = (value) => JSON.parse(JSON.stringify(value));

export const SPARE_MASTER = [
  { id: 'SP-1001', code: 'SP-1001', name: 'Hydraulic Filter Element', category: 'Filtration', uom: 'Nos' },
  { id: 'SP-1002', code: 'SP-1002', name: 'Engine Oil 15W40', category: 'Lubricants', uom: 'Ltr' },
  { id: 'SP-1003', code: 'SP-1003', name: 'Bucket Tooth', category: 'Ground Engaging Tools', uom: 'Nos' },
  { id: 'SP-1004', code: 'SP-1004', name: 'Grease Cartridge', category: 'Lubricants', uom: 'Nos' },
  { id: 'SP-1005', code: 'SP-1005', name: 'Cutting Edge Bolt Kit', category: 'Fasteners', uom: 'Set' },
  { id: 'SP-1006', code: 'SP-1006', name: 'Coolant Concentrate', category: 'Consumables', uom: 'Ltr' },
  { id: 'SP-1007', code: 'SP-1007', name: 'Track Pin Seal Kit', category: 'Undercarriage', uom: 'Kit' }
];

export const LOCATIONS = [
  {
    id: 'LOC-CENTRAL',
    name: 'Central Workshop',
    subLocations: [
      { id: 'SUB-CW-RACK-A', name: 'Rack A' },
      { id: 'SUB-CW-RACK-B', name: 'Rack B' },
      { id: 'SUB-CW-YARD', name: 'Yard Cage' }
    ]
  },
  {
    id: 'LOC-MINE',
    name: 'Mine Store',
    subLocations: [
      { id: 'SUB-MS-BAY-1', name: 'Bay 1' },
      { id: 'SUB-MS-BAY-2', name: 'Bay 2' }
    ]
  }
];

export const INVENTORY_SNAPSHOT = [
  {
    id: 'INV-1',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-RACK-A',
    spareId: 'SP-1001',
    quantity: 12,
    batches: [
      { qty: 5, unitRate: 1420, receivedAt: '2026-01-11' },
      { qty: 7, unitRate: 1485, receivedAt: '2026-03-05' }
    ]
  },
  {
    id: 'INV-2',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-RACK-A',
    spareId: 'SP-1002',
    quantity: 2,
    batches: [
      { qty: 1, unitRate: 118, receivedAt: '2026-01-20' },
      { qty: 1, unitRate: 124, receivedAt: '2026-03-02' }
    ]
  },
  {
    id: 'INV-2B',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-RACK-B',
    spareId: 'SP-1002',
    quantity: 3,
    batches: [
      { qty: 2, unitRate: 120, receivedAt: '2026-01-14' },
      { qty: 1, unitRate: 126, receivedAt: '2026-03-11' }
    ]
  },
  {
    id: 'INV-3',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-RACK-B',
    spareId: 'SP-1003',
    quantity: 9,
    batches: [
      { qty: 4, unitRate: 860, receivedAt: '2025-12-28' },
      { qty: 5, unitRate: 895, receivedAt: '2026-02-18' }
    ]
  },
  {
    id: 'INV-4',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-YARD',
    spareId: 'SP-1004',
    quantity: 6,
    batches: [
      { qty: 6, unitRate: 215, receivedAt: '2026-02-09' }
    ]
  },
  {
    id: 'INV-5',
    locationId: 'LOC-MINE',
    subLocationId: 'SUB-MS-BAY-1',
    spareId: 'SP-1006',
    quantity: 18,
    batches: [
      { qty: 8, unitRate: 340, receivedAt: '2026-01-05' },
      { qty: 10, unitRate: 355, receivedAt: '2026-02-25' }
    ]
  },
  {
    id: 'INV-6',
    locationId: 'LOC-MINE',
    subLocationId: 'SUB-MS-BAY-2',
    spareId: 'SP-1007',
    quantity: 4,
    batches: [
      { qty: 4, unitRate: 1735, receivedAt: '2026-02-01' }
    ]
  }
];

export const SPARE_PURCHASE_HISTORY = [
  { id: 'PH-1', spareId: 'SP-1005', locationId: 'LOC-MINE', unitRate: 78, purchasedAt: '2026-02-12' },
  { id: 'PH-2', spareId: 'SP-1005', locationId: 'LOC-MINE', unitRate: 82, purchasedAt: '2026-03-01' },
  { id: 'PH-3', spareId: 'SP-1002', locationId: 'LOC-CENTRAL', unitRate: 126, purchasedAt: '2026-03-11' },
  { id: 'PH-4', spareId: 'SP-1006', locationId: 'LOC-MINE', unitRate: 355, purchasedAt: '2026-02-25' }
];

const INITIAL_VOUCHERS = [
  {
    id: 'SV-20260318-001',
    voucherNumber: 'SST-001',
    date: '2026-03-17',
    locationId: 'LOC-CENTRAL',
    subLocationId: 'SUB-CW-RACK-A',
    status: 'Submitted',
    submittedAt: '2026-03-17T18:15:00',
    lines: [
      { id: 'LINE-1', spareId: 'SP-1001', quantityFound: 12 },
      { id: 'LINE-2', spareId: 'SP-1002', quantityFound: 3 },
      { id: 'LINE-3', spareId: 'SP-1005', quantityFound: 2 }
    ]
  },
  {
    id: 'SV-20260318-002',
    voucherNumber: 'SST-002',
    date: '2026-03-18',
    locationId: 'LOC-MINE',
    subLocationId: '',
    status: 'Draft',
    submittedAt: null,
    lines: [
      { id: 'LINE-4', spareId: 'SP-1006', quantityFound: 16 }
    ]
  }
];

let vouchers = clone(INITIAL_VOUCHERS);
let adjustmentVouchers = [];
const listeners = new Set();

const emit = () => {
  const voucherSnapshot = clone(vouchers);
  const adjustmentSnapshot = clone(adjustmentVouchers);
  listeners.forEach((listener) => listener(voucherSnapshot, adjustmentSnapshot));
};

const nextVoucherNumber = () => {
  const current = vouchers.length + 1;
  return `SST-${String(current).padStart(3, '0')}`;
};

const nextVoucherId = () => `SV-${Date.now()}`;
const nextLineId = () => `LINE-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

export const getLocations = () => clone(LOCATIONS);
export const getSpareMaster = () => clone(SPARE_MASTER);
export const getInventorySnapshot = () => clone(INVENTORY_SNAPSHOT);
export const getSparePurchaseHistory = () => clone(SPARE_PURCHASE_HISTORY);
export const getStockTakingVouchers = () => clone(vouchers);
export const getAdjustmentVouchers = () => clone(adjustmentVouchers);
export const getVoucherById = (id) => clone(vouchers.find((voucher) => voucher.id === id) || null);

export const subscribeToSparesStore = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const createVoucher = ({ date, locationId, subLocationId }) => {
  const voucher = {
    id: nextVoucherId(),
    voucherNumber: nextVoucherNumber(),
    date: moment(date).format('YYYY-MM-DD'),
    locationId,
    subLocationId: subLocationId || '',
    status: 'Draft',
    submittedAt: null,
    lines: []
  };
  vouchers = [voucher, ...vouchers];
  emit();
  return clone(voucher);
};

export const updateVoucherHeader = (voucherId, updates) => {
  vouchers = vouchers.map((voucher) => {
    if (voucher.id !== voucherId || voucher.status !== 'Draft') return voucher;
    return {
      ...voucher,
      ...updates,
      date: updates.date ? moment(updates.date).format('YYYY-MM-DD') : voucher.date,
      subLocationId: updates.subLocationId || ''
    };
  });
  emit();
};

export const addVoucherLine = (voucherId, { spareId, quantityFound }) => {
  vouchers = vouchers.map((voucher) => {
    if (voucher.id !== voucherId || voucher.status !== 'Draft') return voucher;
    return {
      ...voucher,
      lines: [...voucher.lines, { id: nextLineId(), spareId, quantityFound: Number(quantityFound) }]
    };
  });
  emit();
};

export const removeVoucherLine = (voucherId, lineId) => {
  vouchers = vouchers.map((voucher) => {
    if (voucher.id !== voucherId || voucher.status !== 'Draft') return voucher;
    return {
      ...voucher,
      lines: voucher.lines.filter((line) => line.id !== lineId)
    };
  });
  emit();
};

export const submitVoucher = (voucherId) => {
  vouchers = vouchers.map((voucher) => {
    if (voucher.id !== voucherId || voucher.status !== 'Draft') return voucher;
    return {
      ...voucher,
      status: 'Submitted',
      submittedAt: new Date().toISOString()
    };
  });
  emit();
};

export const createAdjustmentVoucher = (payload) => {
  const adjustmentVoucher = {
    id: `SAV-${Date.now()}`,
    voucherNumber: `SAV-${String(adjustmentVouchers.length + 1).padStart(3, '0')}`,
    createdAt: new Date().toISOString(),
    ...payload
  };
  adjustmentVouchers = [adjustmentVoucher, ...adjustmentVouchers];
  emit();
  return clone(adjustmentVoucher);
};
